import { render, staticRenderFns } from "./ChaperoneAutoComplete.vue?vue&type=template&id=3c70cb38&"
import script from "./ChaperoneAutoComplete.vue?vue&type=script&lang=js&"
export * from "./ChaperoneAutoComplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports